import React, { useEffect, useRef, useState, memo } from 'react';
import FooterSection from "../Components/FooterSection";
import Header from '../Components/Header';
import PageTitleSection from "../Components/PageTitleSection";
import Spacer from "../Components/Spacer";
import HttpHelper from '../service/httpService'
const Jobs = () => {

    const [jobListing, setJobListing] = useState({});

    const GetJobListing = async (data) => {
        await HttpHelper.get("Website/GetJobListing", data).then((response) => {
            setJobListing(response.data);
            console.log(jobListing)
        })
    }

    useEffect(() => {
        GetJobListing();
    }, []);

    return (<>
        <Header />
        <PageTitleSection
            title="Jobs"
            pagetitle="Jobs"
        />

        <section className="section">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <table className="table tableCustomized">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Location</th>
                                    <th>Open Date</th>
                                    <th>Close Date</th>
                                    <th>Contact Info</th>
                                    <th>Url</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    jobListing != null && jobListing.length > 0 ? jobListing.map((item, index) => {
                                        return (
                                            <tr>
                                                <td>{item.title}</td>
                                                <td>{item.location}</td>
                                                <td>{item.openDate}</td>
                                                <td>{item.closeDate}</td>
                                                <td>{item.contactInfo}</td>
                                                <td><a href={item.url} target="_blank">{item.url}</a></td>
                                            </tr>
                                        )
                                    }) : null
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
        <Spacer />
        <FooterSection />
    </>)
}

export default memo(Jobs);